import React, { useState } from 'react';
import { PageHeader } from '../components/common/PageHeader';
import { SendIcon } from 'lucide-react';
export function Tools() {
  const [msg, setMsg] = useState('');
  const [chat, setChat] = useState([{
    role: 'cs',
    text: '您好！我是您的专属 1v1 留学顾问。请问有什么可以帮您？'
  }]);
  const send = () => {
    if (!msg.trim()) return;
    setChat([...chat, {
      role: 'user',
      text: msg
    }]);
    setMsg('');
    setTimeout(() => {
      setChat(prev => [...prev, {
        role: 'cs',
        text: '顾问已收到您的消息，正在为您匹配最优方案，请稍候...'
      }]);
    }, 1000);
  };
  return <div className="bg-slate-50 min-h-screen flex flex-col pb-14" data-id="element-736">
      <PageHeader title="1v1 专属顾问" data-id="element-737" />

      <div className="flex-1 overflow-y-auto p-4 space-y-4" data-id="element-738">
        {chat.map((c, i) => <div key={i} className={`flex gap-2 max-w-[85%] ${c.role === 'user' ? 'ml-auto flex-row-reverse' : ''}`} data-id="element-739">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 text-xs text-white ${c.role === 'user' ? 'bg-slate-800' : 'bg-blue-600'}`} data-id="element-740">
              {c.role === 'user' ? '我' : '顾'}
            </div>
            <div className={`rounded-2xl p-3 text-sm shadow-sm ${c.role === 'user' ? 'bg-blue-600 text-white rounded-tr-sm' : 'bg-white text-slate-700 rounded-tl-sm'}`} data-id="element-741">
              {c.text}
            </div>
          </div>)}
      </div>

      <div className="bg-white border-t border-slate-100 p-2 flex gap-2 items-center" data-id="element-742">
        <input value={msg} onChange={e => setMsg(e.target.value)} placeholder="输入消息咨询顾问..." className="flex-1 h-10 px-4 rounded-full bg-slate-100 text-sm outline-none" onKeyDown={e => e.key === 'Enter' && send()} data-id="element-743" />
        <button onClick={send} className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center shrink-0" data-id="element-744">
          <SendIcon size={16} className="-ml-0.5" data-id="element-745" />
        </button>
      </div>
    </div>;
}